var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#4A4A4A",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#message_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M16.668 7.5c-.663-3.32-3.74-5.833-7.434-5.833-4.178 0-7.566 3.213-7.566 7.175 0 1.904.782 3.634 2.057 4.917.28.283.468.67.393 1.067a3.95 3.95 0 0 1-.822 1.76c1.09.202 2.223.02 3.195-.492.344-.18.516-.271.637-.29.085-.013.195 0 .373.03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.168 13.552c0 2.421 2.052 4.384 4.583 4.384q.448 0 .887-.081c.21-.04.316-.06.39-.049.072.012.177.067.385.178a2.98 2.98 0 0 0 1.936.3 2.4 2.4 0 0 1-.498-1.076c-.046-.242.067-.478.238-.651a4.27 4.27 0 0 0 1.246-3.005c0-2.422-2.053-4.385-4.584-4.385s-4.583 1.963-4.583 4.385Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "message_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgMessage;